<template>
  <v-select
    :items="listaDeOrganizacoes"
    item-value="idExterno"
    item-text="nome"
    label="Organizações"
    class="autocomplete"
    :no-data-text="this.carregando ? 'Buscando organizações...' : 'Não há organizações'"
    :loading="carregando"
    return-object
    v-model="organizacao"
    :disabled="desativarSelectOrganizacao"
    @input="salvarOrganizacaoNaMemoria()"
  >
    <template slot="item" scope="data">
      <v-list-item-content>
        <v-list-item-title>{{ data.item.nome }}</v-list-item-title>
        <v-list-item-subtitle>{{ exibirOrganizacoesPai(data.item) }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import { headersPadrao } from "../../../mixins/HeadersMixin";
import { receber } from "../../../mixins/RequisicaoMixin";
import { mapActions, mapState } from "vuex";
  
export default {
  data: () => ({
    listaDeOrganizacoes: [],
    organizacao: "",
    carregando: false
  }),
  computed: {
     ...mapState([
      "desativarSelectOrganizacao"
    ])
  },
  methods: {
    ...mapActions([
      "desativarComponenteOrganizacao",
      "atualizarConteudoAssinatura"
    ]),

    buscarOrganizacoes() {
      this.carregando = true;
      var idDoCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
      var url = `api/v1/multisign/busca?tipo=organizacoes&cliente=${idDoCliente}&grupos=`;
      receber(url, headersPadrao())
        .then(organizacoes => {
          const organizacoesTratadas = this.montarListaDeOrgs(organizacoes);
          this.listaDeOrganizacoes = organizacoesTratadas.sort(this.ordernarPorNomeDaOrg);
        })
        .catch(() => {
          this.$store.commit(
            "erro",
            "Erro ao buscar organizações. Verifique se as configurações para este cliente foram realizadas corretamente."
          );
        }).finally(() => {
           this.carregando = false;
        })
    },  
    salvarOrganizacaoNaMemoria(){
      this.atualizarConteudoAssinatura('Organizacao')
      this.desativarComponenteOrganizacao(true);
      var organizacaoFormatada = Object.assign({}, this.organizacao);
      organizacaoFormatada.id = organizacaoFormatada.idExterno;
      organizacaoFormatada.tipo = "organizacao";
      delete organizacaoFormatada.idExterno;
      this.$store.commit("adicionarOrganizacaoOuGrupo", organizacaoFormatada);
    },
    montarListaDeOrgs(organizacoes){
      return this.separarOrgsFilhasEPais(organizacoes);
    },
    separarOrgsFilhasEPais(organizacoes){
      const orgsPai = organizacoes.filter(org => org.pathPai == null);
      const orgsFilha = organizacoes.filter(org => org.pathPai != null);
      return this.formatarOrgsESuborgs(orgsPai, orgsFilha);
    },
    formatarOrgsESuborgs(orgsPai, orgsFilha){
      var listaDeOrganizacoes = orgsPai;
      listaDeOrganizacoes = this.inserirCampoOrgPaiNosObjetosDaLista(listaDeOrganizacoes); 
      for(var j = 0; j < listaDeOrganizacoes.length; j++){
        for(var i = 0; i < orgsFilha.length; i++){
          if(listaDeOrganizacoes[j].path == orgsFilha[i].pathPai) {
            var indexDaOrgPai = listaDeOrganizacoes.indexOf(listaDeOrganizacoes[j]);
            orgsFilha[i].orgPai = listaDeOrganizacoes[indexDaOrgPai].nome;
            listaDeOrganizacoes.splice(indexDaOrgPai + 1, 0, orgsFilha[i]);
          }
        }
      }
      return listaDeOrganizacoes;
    },
    inserirCampoOrgPaiNosObjetosDaLista(organizacoes){
      for(var i = 0; i < organizacoes.length; i++) organizacoes[i].orgPai = "";
      return organizacoes;
    },
    ordernarPorNomeDaOrg(orgA, orgB){
      if (orgA.nome.toLowerCase() > orgB.nome.toLowerCase()) return 1;
      if (orgA.nome.toLowerCase() < orgB.nome.toLowerCase()) return -1;
      return 0;
    },
    formatarPath(pathDaOrganizacao, nomeDaOrganizacao){
      var pathSemNomeDaOrg = this.removerNomeDaOrgNoPath(pathDaOrganizacao, nomeDaOrganizacao);
      var pathSemBarra = pathSemNomeDaOrg.replace(/\//g, " - ");
      var pathSemIfemNoComeco = pathSemBarra.replace(" - ", "");
      return pathSemIfemNoComeco;
    },
    removerNomeDaOrgNoPath(pathDaOrganizacao, nomeDaOrganizacao){
      var pathDaOrganizacaoSemNomeDaOrg = pathDaOrganizacao.replace(`/${nomeDaOrganizacao}`, "");
      return pathDaOrganizacaoSemNomeDaOrg;
    },
    exibirOrganizacoesPai(organizacao){
      const orgSoTemPai = organizacao.pathPai == '/'
      if(orgSoTemPai) return organizacao.orgPai;
      else return this.formatarPath(organizacao.path, organizacao.nome);
    }
  },
  created() {
    this.buscarOrganizacoes();
  }
};
</script>

<style lang="css">
.autocomplete {
  padding: 0.5rem 1rem 0.3rem 1rem;
}
.titulo-label {
  font-weight: normal !important;
}
</style>

